
import ParallelFields from '@/pages/search/form/parallel/ParallelFields';

import SelectPicker from '@/components/SelectPicker.vue';
import MultiValuePicker from '@/components/MultiValuePicker.vue';
import AlignBy from '@/pages/search/form/AlignBy.vue';

export default ParallelFields.extend({
	components: {
		SelectPicker,
		MultiValuePicker,
		AlignBy,
	},
	props: {
		block: {default: false, type: Boolean},
		lg: {default: false, type: Boolean},
	},
});
